/** @format */

import {AreaChartMultiDataType} from '../index';

interface Props {
  x: number;
  y: number;
  payload: {
    value: string;
  };
  data: AreaChartMultiDataType[];
}

const CustomXTickMonth = ({payload, y, x, data}: Props) => {
  const value = payload.value;

  const tickData = data.find(item => item.name === value);
  const monthName = tickData ? tickData.month : '';

  if (!monthName) {
    return null;
  }

  return (
    <text dy={0} dx={-3} fill='#FFFFFF' fontSize={12} fontWeight='400' x={x} y={y}>
      {monthName}
    </text>
  );
};

export {CustomXTickMonth};
